import React, { useEffect, useRef } from 'react'
import { Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, Text, VStack, Box, HStack, Image } from '@chakra-ui/react'

export interface IPhoneModalProps {
  isOpen: boolean
  onClose: () => void
}

export const IPhoneModal: React.FC<IPhoneModalProps> = ({ isOpen, onClose }) => {
  const onCloseRef = useRef(onClose)
  useEffect(() => {
    onCloseRef.current = onClose
  }, [onClose])


  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent bg="#0f0f12" color="white" borderRadius="lg" border="1px solid" borderColor="gray.700" maxW="360px">
        <ModalBody p={8} pb={40}>
          <VStack spacing={4} align="center" w="100%">
            <Text fontSize="2xl" fontWeight="bold" color="#3182ce" textAlign="center">
              Using an iPhone?
            </Text>

            <Text fontSize="md" color="gray.400" textAlign="center">Requires latest iOS update &gt;26.2</Text>
            <Text fontSize="md" color="gray.400" mb={4} textAlign="center">&gt;20% battery</Text>

            <Box w="100%" mb={2}>
              <Text fontSize="md" textAlign="left">You must go to:</Text>
            </Box>
            <VStack spacing={3} align="start" w="100%">
              <HStack spacing={2} align="center">
                <Text>1.</Text>
                <Image src="/iPhoneAppButton.jpg" alt="Settings App icon" boxSize="22px" borderRadius="md" />
                <Text>Settings App</Text>
              </HStack>

              <HStack spacing={2} align="center">
                <Text>2.</Text>
                <Image src="/iPhoneDisplayBrightness.jpg" alt="Display & Brightness icon" boxSize="22px" borderRadius="md" />
                <Text>Display &amp; Brightness</Text>
              </HStack>

              <HStack spacing={2} align="center">
                <Text>3.</Text>
                <Text>Auto-Lock → <Text as="span" color="#3182ce">Never</Text></Text>
              </HStack>
            </VStack>

            <Box h={12} />

            {/* Close Icon at Bottom Center */}
          </VStack>
        </ModalBody>
        <ModalCloseButton 
          onClick={onClose}
          _focus={{ boxShadow: 'none' }} 
          position="absolute" 
          top="auto"
          right="auto"
          bottom={2} 
          left="50%" 
          transform="translateX(-50%)" 
          size="lg"
          boxSize="56px"
          bg="#1f2937"
          color="white"
          borderRadius="6px"
          border="1px solid"
          borderColor="gray.600"
          _hover={{ bg: '#374151' }}
        />
      </ModalContent>
    </Modal>
  )
}


